import styled from "styled-components";
import { PriceCaption } from "../../../../cards/product-card/views/desktop/prices/styled.js";
import { Company } from "../../../../cards/product-card/views/desktop/styled.js";
import { CarouselProductBox } from "../../../../carousels/carousel-product/views/desktop/styled.js";
import { GridWrapper } from "../../../grid-product/views/desktop/styled.js";
import TabsDefault from "../../../../../structures/others/tabs/index.js";
import { FontMixin } from "../../../../../../styles/common/mixins/helpers.styled.js";
export const TabsProductBox = styled.div.withConfig({
    displayName: "styled__TabsProductBox",
    componentId: "sc-b06c5a52-0"
})`
	${CarouselProductBox} {
		${({ $isFlat  })=>!$isFlat ? `padding: 16px 32px;` : 'padding: 16px 0;'}
	}

	${GridWrapper} {
		${({ $isFlat  })=>!$isFlat ? `padding: 16px;` : 'padding: 16px 0;'}
	}

	& .tab-header ul > li {
		min-width: calc(100% / 5);
	}

	& .tab-header ul > li .is-deal {
		${FontMixin({
    weight: 'medium'
})}
		color: ${({ theme  })=>theme.colors.status.offer};
	}

	& .tab-header ul > li button.is-active:has(.is-deal) {
		border-color: ${({ theme  })=>theme.colors.status.offer};
	}

	// TRANSPORT

	${Company} {
		border: none;
		min-width: auto;
		padding-right: 4px;
		margin-right: auto;
		img {
			border: 1px solid ${({ theme  })=>theme.colors.grays.light};
			border-radius: 50%;
		}
	}

	${PriceCaption} {
		order: -1;
		color: ${({ theme  })=>theme.colors.secondary.base};
		font-weight: ${({ theme  })=>theme.font.weight.light};
	}
	// END TRANSPORT
`;
export const Tabs = styled(TabsDefault).withConfig({
    displayName: "styled__Tabs",
    componentId: "sc-b06c5a52-1"
})`
	${({ $isFlat  })=>$isFlat ? `
				box-shadow: none;
				border-radius: none;
				background-color: transparent;
				` : ''};
`;
export const CarouselProduct = styled.div.withConfig({
    displayName: "styled__CarouselProduct",
    componentId: "sc-b06c5a52-2"
})``;

//# sourceMappingURL=styled.js.map